import { Box, Text, VStack, Checkbox } from '@chakra-ui/react';
import { Scrollbars } from 'react-custom-scrollbars-2';

import type { APIRemarkFile } from 'types/api.types';
import { getFileId, getFileLabel, isFileDisabled } from '../helpers';
import {
  renderThumb,
  renderTrack,
  renderView,
} from 'components/scrollbar/Scrollbar';

interface FileUploadsColumnProps {
  files: APIRemarkFile[];
  validations: Validation[];
  selectedFiles: string[];
  selectedValidations: string[];
  onToggle: (id: string) => void;
}

const FileUploadsColumn = ({
  files,
  validations,
  selectedFiles,
  selectedValidations,
  onToggle,
}: FileUploadsColumnProps) => {
  return (
    <Box flex="1" w={{ base: '100%', lg: 'auto' }}>
      <Text fontWeight="bold" fontSize="lg" mb={3}>
        File Uploads
      </Text>
      <Box h={{ base: '200px', lg: '300px' }}>
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
        >
          <VStack align="stretch" spacing={2} width="100%" pl={2} pb={8}>
            {files.length === 0 ? (
              <Text color="gray.500" fontSize="sm">
                No missing file uploads
              </Text>
            ) : (
              files.map((file) => {
                const fileId = getFileId(file);
                const disabled = isFileDisabled(file, selectedValidations);
                return (
                  <Checkbox
                    key={fileId}
                    isChecked={selectedFiles.includes(fileId)}
                    onChange={() => onToggle(fileId)}
                    isDisabled={disabled}
                  >
                    <Text fontSize="sm" fontWeight="medium">
                      {getFileLabel(file, validations)}
                    </Text>
                    {file.text && (
                      <Text fontSize="xs" color="gray.600">
                        {file.text}
                      </Text>
                    )}
                  </Checkbox>
                );
              })
            )}
          </VStack>
        </Scrollbars>
      </Box>
    </Box>
  );
};

export default FileUploadsColumn;
